import analytics, { events } from '../../../shared/analytics';
import UiElement from '../../../shared/ui-element/ui-element';

import './macpaw-birthday-banner.scss';

class MacpawBirthdayBanner extends UiElement {
  ui = {
    banner: '.js-mac-paw-birthday-banner',
  };

  events = {
    'click @ui.banner': 'handleBannerClick',
  };

  handleBannerClick() {
    analytics.trackEvent({
      ...events.MAC_PAW_BIRTHDAY_15,
    });
  }
}

export default MacpawBirthdayBanner;
